import React from "react";
import ReactHtmlParser from "react-html-parser";
import "./index.css";
const user_verification = require("../../../../assets/media/portal_icons/User_Verification.png");
const travel_concierge = require("../../../../assets/media/portal_icons/Travel_Concierge.png");
const rent_reference = require("../../../../assets/media/portal_icons/Rent_Reference.png");
const property_manager = require("../../../../assets/media/portal_icons/Property_Manager.png");
const contractor_portal = require("../../../../assets/media/portal_icons/Contractor_Portal.png");
const concierge_robot = require("../../../../assets/media/portal_icons/Concierge_Robot.png");
const cloud_marketplace = require("../../../../assets/media/portal_icons/Cloud_Marketplace.png");
const cloud_community = require("../../../../assets/media/portal_icons/Cloud_Community.png");
const chat_suite = require("../../../../assets/media/portal_icons/Chat_Suite.png");

const getName = (name) => {
  switch (name) {
    case "Property reference":
      return "Referencing Tool";
    case "Property Manager":
      return "Property Manager Hub";
    case "Property Tasks":
      return "Property Tasker Hub";
    default:
      return name;
  }
};
const getIcon = (name) => {
  switch (name) {
    case "Concierge":
      return concierge_robot;
    case "Chat Suite":
      return chat_suite;
    case "User verification":
      return user_verification;
    case "Travel Tool":
      return travel_concierge;
    case "Shop Tool":
      return cloud_marketplace;
    case "Community Tool":
      return cloud_community;
    case "Property reference":
      return rent_reference;
    case "Property Manager":
      return property_manager;
    case "Property Tasks":
      return contractor_portal;
    default:
      return concierge_robot;
  }
};
const getDetail = (name) => {
  switch (name) {
    case "Concierge":
      return "A platform driving insider value for closed user groups, with discounts, extras, vip treatment and cashback.";
    case "Chat Suite":
      return "Interact with your users through one streamlined chat. Manage tickets and SLAs throughout the your user groups.";
    case "User verification":
      return "A chat driven profiler which tests ID, KYC, credit, affordability & historical data. \n For tenants or employees.";
    case "Travel Tool":
      return "A chat driven profiler which tests ID, KYC, credit, affordability & historical data. \n For tenants or employees.";
    case "Shop Tool":
      return "Monetise your users and drive loyalty by turning them into premium members, using our white-label tech.";
    case "Community Tool":
      return "Monetise your users and drive loyalty by turning them into premium members, using our white-label tech.";
    case "Property reference":
      return "A platform driving insider value for closed user groups, with discounts, extras, vip treatment and cashback.";
    case "Property Manager":
      return "Manages & covers all risk on verified properties. \nPuts residents & contractors in control of driving solutions.";
    case "Property Tasks":
      return "A chatbot concierge managing all life & home wants & needs. \n Engage & monetize users.";
    default:
      return "A platform driving insider value for closed user groups, with discounts, extras, vip treatment and cashback.";
  }
};
class PortalCard extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      total: 0,
      open: 0,
      close: 0,
      waiting: 0,
    };
  }
  componentDidMount() {
    const { portal } = this.props;
  }
  componentWillReceiveProps(nextProps) {}
  activePortal = () => {
    const { activePortal } = this.props;
    console.log("actived portal in PortalCard");
    activePortal();
  };
  render() {
    const { portal, brand, index } = this.props;
    const icon = getIcon(portal.name);
    const active = portal.active;
    const url = portal.url;
    let brand_name = brand.replace(/\s/g, "");
    let active_url = url;
    if (index === 0 || index === 2 || index === 3 || index === 4 || index === 5)
      active_url = url + "/" + brand_name;
    return (
      <div className="portalcard-content">
        <div
          className="block block-link-pop text-center"
          style={{ padding: 10, height: "100%" }}
        >
          <div
            style={{
              backgroundImage: `url(${icon})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "contain",
              padding: 20,
              width: "100%",
              height: 70,
            }}
          ></div>
          <h3>{getName(portal.name)}</h3>
          {/* <div>{ReactHtmlParser(getDetail(portal.name))}</div> */}
          {/* {active && ( */}
          <a href={active_url} target="_blank">
            <button className="btn btn-success">Visit</button>
          </a>
          {/* )} */}
          {/* {!active && (
            <button
              className="btn btn-warning"
              onClick={() => this.activePortal()}
            >
              Activate
            </button>
          )} */}
        </div>
      </div>
    );
  }
}
export default PortalCard;



// WEBPACK FOOTER //
// ./src/screens/PropertyPortals/components/PortalCard/index.js